// @ts-nocheck
import {
  Fragment,
  useEffect,
  useRef,
  useState,
  Ref,
  useMemo,
  useCallback,
} from "react";
import Image from "src/components/image";

import { AMPLITUDE_EVENT, EVENT, trackGAEvent } from "@/utils/analytics";
import { trackEvent } from "@/amplitudeClient";

import {
  findMapAlignWithLcMapId,
  getVenueIdByVenueCode,
  getBaseUrl,
  getVenueNameByVenueCode,
  getMapSettingByVenueCode,
  getModelConfigMapByLcMapId,
} from "src/utils/map-util";

import { useExplorationStore } from "@/store/explorationStore";

import { initCameraMovement } from "src/const/explorationConst";

import {
  interpolateVector3,
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  wrapAngle,
  tri,
  getBackPositionWithDistance,
  getNewFrontPosition,
} from "src/utils/game";
import * as pc from "playcanvas";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
  useFont,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
  Screen,
  Element,
  RigidBody,
  Collision,
} from "@playcanvas/react/components";
import { Texture } from "@playcanvas/engine"; // For texture loading

import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import WatermarkScreen from "src/components/watermark";
import { useLodSplat } from "src/utils/useLodSplat";

import Lottie from "lottie-react";
import loading from "src/components/lottie/loading.json";

import { GsplatRevealRadial } from "src/extra_js/reveal-radial.mjs";

import {
  createRadialScript,
  SplatLodComponent,
  SplatSogComponent,
  RobotAvatar,
  MeshModelComponent,
  FloorMeshComponent,
  installCameraNearFar,
} from "@/components/playcanvas/playcanvasComponents";

// import fontAsset from '@/assets/playcanvas_font/arial.json';

export default function ExploreIndoorPage() {
  const setCameraPosition = useExplorationStore(
    (state) => state.setCameraPosition,
  );
  const setCameraLookingPosition = useExplorationStore(
    (state) => state.setCameraLookingPosition,
  );
  const setCameraAngle = useExplorationStore((state) => state.setCameraAngle);
  const setCurrentVenueName = useExplorationStore(
    (state) => state.setCurrentVenueName,
  );
  const setCurrentLcMapId = useExplorationStore(
    (state) => state.setCurrentLcMapId,
  );

  const setExploratingPosition = useExplorationStore(
    (state) => state.setExploratingPosition,
  );
  const setExploratingAngle = useExplorationStore(
    (state) => state.setExploratingAngle,
  );
  const setIsDisplayUI = useExplorationStore((state) => state.setIsDisplayUI);
  const setIsDisplayTopViewScene = useExplorationStore(
    (state) => state.setIsDisplayTopViewScene,
  );

  const enableXRayMode = useExplorationStore((state) => state.enableXRayMode);
  const setSceneAnimationState = useExplorationStore(
    (state) => state.setSceneAnimationState,
  );

  const triggerResetPositionRotationEvent = useExplorationStore(
    (state) => state.triggerResetPositionRotationEvent,
  );

  const THIRD_PERSION_DISTANCE = 4;
  const SCALE_BASE = 1500;

  const [mapSettingState, setMapSettingState] = useState<IMapAlign>(null);
  const modelScaleFactorRef = useRef(1);

  const gsplatMainRef = useRef();
  const gsplatAllRef = useRef({});
  const splatDisplayLcMapIdRef = useRef<number[]>();

  const moveSpeedRef = useRef<number>(1);
  const rotateSpeedRef = useRef<number>(1);
  const downSpeedRef = useRef<number>(1);

  const topPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const downPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const backPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

  const targetAltitudeRef = useRef<number>(0);

  const currentLcMapIdRef = useRef<string>("");
  const isLevelChangingRef = useRef<boolean>(false);

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestCameraModeRef = useRef<number>(0);
  const latestXrayModeRef = useRef<number>(0);

  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const revealEffectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const [modelLoadedState, setModelLoadedState] = useState(false);
  const [coordReadyState, setCoordReadyState] = useState(false);

  const startPosRef = useRef(new pc.Vec3());
  const endPosRef = useRef(new pc.Vec3());

  const [startTransition, setStartTransition] = useState(false);

  const toggleResetRef = useRef(false);

  // const controls = useRef<any>(null);
  // const navigationObject = useRef<Group | null>(null);
  // const firstPersonCameraVector = useRef<Group | null>(null);
  // const thirdPersonCameraVector = useRef<Group | null>(null);

  const isMovingRef = useRef<boolean>(false);
  const isRotatingRef = useRef<boolean>(false);

  const latestPositionJoystickData = useRef<number[]>([0, 0]);
  const latestRotationJoystickData = useRef<number[]>([0, 0]);
  const latestRotationScreenData = useRef<number[]>([0, 0]);

  const latestResetPositionRotationEvent = useRef<number>(0);
  const latestResetOnlyRotationEvent = useRef<number>(0);
  const leaveVenueRef = useRef<number>(0);

  const sceneAnimationStateRef = useRef("init");

  const isDisplayAvatarRef = useRef<boolean>(false);

  const isDisplayEnteringMaskRef = useRef<boolean>(false);
  const isDisplayLeavingMaskRef = useRef<boolean>(false);
  const isDisplayVenueNameRef = useRef<boolean>(false);

  const isSplatLoadingRef = useRef();
  const splatLoadingCountRef = useRef();

  const DataController = () => {
    const currentVenue = useExplorationStore((state) => state.currentVenue);
    useEffect(() => {
      console.log("init data " + currentVenue);
      if (!currentVenue) {
        return;
      }
      const mapSetting = getMapSettingByVenueCode(currentVenue);
      setMapSettingState(mapSetting);
      setCurrentVenueName(mapSetting.venueName);
      moveSpeedRef.current = mapSetting.modelConfig.moveSpeed;
      rotateSpeedRef.current = mapSetting.modelConfig.rotateSpeed;
      downSpeedRef.current = mapSetting.modelConfig.downSpeed;

      const floorNamelist = mapSetting.modelConfig.floor.map((f) => f.name);
      const defaultFloor = mapSetting.modelConfig.floor.find(
        (floor) => floor.lcMapId === mapSetting.modelConfig.defaultLcMapId,
      );
      if (currentLcMapId == "") {
        setCurrentLcMapId(defaultFloor.lcMapId ?? "");
      }

      const defaultFloorMapAlign = mapSetting.floorAlignment.find(
        (floor) => floor.lcMapId === mapSetting.modelConfig.defaultLcMapId,
      );

      const scaleFactor = SCALE_BASE / defaultFloorMapAlign.scale;
      modelScaleFactorRef.current = scaleFactor;

      const defaultPosition = new pc.Vec3(
        mapSetting.modelConfig.defaultPosition[0] / scaleFactor,
        mapSetting.modelConfig.defaultPosition[1] / scaleFactor,
        mapSetting.modelConfig.defaultPosition[2] / scaleFactor,
      );

      const defaultTarget = new pc.Vec3(
        mapSetting.modelConfig.defaultTarget[0] / scaleFactor,
        mapSetting.modelConfig.defaultTarget[1] / scaleFactor,
        mapSetting.modelConfig.defaultTarget[2] / scaleFactor,
      );

      const frontPosition = getNewFrontPosition(
        defaultPosition,
        defaultTarget,
        3,
      );

      topPositionRef.current = new pc.Vec3(
        frontPosition.x,
        mapSetting.modelConfig.topAltitude / scaleFactor,
        frontPosition.z,
      );

      downPositionRef.current = new pc.Vec3(
        frontPosition.x,
        frontPosition.y,
        frontPosition.z,
      );

      const backPosition = getBackPositionWithDistance(
        defaultPosition,
        defaultTarget,
        3,
      );

      backPositionRef.current = new pc.Vec3(
        backPosition.x,
        backPosition.y,
        backPosition.z,
      );

      defaultPositionRef.current = new pc.Vec3(
        defaultPosition.x,
        (defaultFloor?.altitude ?? 0) / scaleFactor,
        defaultPosition.z,
      );

      defaultTargetRef.current = new pc.Vec3(
        defaultTarget.x,
        (defaultFloor?.altitude ?? 0) / scaleFactor,
        defaultTarget.z,
      );

      setCoordReadyState(true);

      // console.log(mapSetting.modelConfig.modelConfig);

      if (mapSetting.modelConfig && !mapSetting.modelConfig?.splat) {
        console.log("skip 3dGS !!!!");
        setModelLoadedState(true);
      }
    }, [currentVenue]);

    const cameraMode = useExplorationStore((state) => state.cameraMode);
    useEffect(() => {
      latestCameraModeRef.current = cameraMode;
    }, [cameraMode]);

    const xRayMode = useExplorationStore((state) => state.xRayMode);
    const reEnableSplat = (splat) => {
      if (splat.enabled) {
        requestAnimationFrame((timestamp) => {
          reEnableSplat(splat);
        });
      } else {
        splat.enabled = true;
      }
    };
    useEffect(() => {
      latestXrayModeRef.current = xRayMode;
      const opacity = xRayMode === 2 ? 0.05 : 1.0;
      for (const [key, eachSplat] of Object.entries(gsplatAllRef.current)) {
        if (eachSplat) {
          if (
            eachSplat.gsplat == null ||
            eachSplat.gsplat.setWorkBufferModifier == null
          ) {
            return;
          }
          eachSplat.gsplat.setWorkBufferModifier({
            glsl: `
              void modifySplatCenter(inout vec3 center) {}
              void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {}
              void modifySplatColor(vec3 center, inout vec4 color) { color.a *= ${opacity.toFixed(1)}; }
            `,
          });
          if (eachSplat.enabled) {
            eachSplat.enabled = false;
            requestAnimationFrame((timestamp) => {
              reEnableSplat(eachSplat);
            });
          }
        }
      }
    }, [xRayMode]);

    const currentLcMapId = useExplorationStore((state) => state.currentLcMapId);
    useEffect(() => {
      if (
        currentVenue == null ||
        currentVenue == "" ||
        currentLcMapId == null ||
        currentLcMapId == ""
      ) {
        return;
      }
      const mapSetting = getMapSettingByVenueCode(currentVenue);
      const modelConfigMap = getModelConfigMapByLcMapId(
        mapSetting.modelConfig,
        currentLcMapId,
      );
      const mapAlign = findMapAlignWithLcMapId(
        mapSetting.floorAlignment,
        currentLcMapId,
      );
      modelScaleFactorRef.current = SCALE_BASE / mapAlign.scale;
      const altitude = modelConfigMap.altitude;
      targetAltitudeRef.current = altitude / modelScaleFactorRef.current;
      isLevelChangingRef.current = true;
      currentLcMapIdRef.current = currentLcMapId;
    }, [currentLcMapId, currentVenue]);

    const resetPositionRotationEvent = useExplorationStore(
      (state) => state.resetPositionRotationEvent,
    );
    useEffect(() => {
      latestResetPositionRotationEvent.current = resetPositionRotationEvent;
    }, [resetPositionRotationEvent]);

    const resetOnlyRotationEvent = useExplorationStore(
      (state) => state.resetOnlyRotationEvent,
    );
    useEffect(() => {
      latestResetOnlyRotationEvent.current = resetOnlyRotationEvent;
    }, [resetOnlyRotationEvent]);

    const leaveVenueEvent = useExplorationStore(
      (state) => state.leaveVenueEvent,
    );
    useEffect(() => {
      leaveVenueRef.current = leaveVenueEvent;
    }, [leaveVenueEvent]);

    const sceneAnimationState = useExplorationStore(
      (state) => state.sceneAnimationState,
    );
    useEffect(() => {
      sceneAnimationStateRef.current = sceneAnimationState;
    }, [sceneAnimationState]);

    const positionJoystickData = useExplorationStore(
      (state) => state.positionJoystickData,
    );
    const rotationJoystickData = useExplorationStore(
      (state) => state.rotationJoystickData,
    );

    useEffect(() => {
      latestPositionJoystickData.current = [
        positionJoystickData[0],
        positionJoystickData[1],
      ];
      trackGAEvent(EVENT.EXPLORE_JOYSTICK_INTERACTION, {
        mode: "exploration",
        currentVenue,
        type: "position",
      });
      trackEvent(AMPLITUDE_EVENT.EXPLORE_JOYSTICK_INTERACTION, {
        mode: "exploration",
        currentVenue,
        type: "position",
      });
    }, [positionJoystickData]);

    useEffect(() => {
      latestRotationJoystickData.current = [
        rotationJoystickData[0],
        rotationJoystickData[1],
      ];
      trackGAEvent(EVENT.EXPLORE_JOYSTICK_INTERACTION, {
        mode: "exploration",
        currentVenue,
        type: "rotation",
      });
      trackEvent(AMPLITUDE_EVENT.EXPLORE_JOYSTICK_INTERACTION, {
        mode: "exploration",
        currentVenue,
        type: "rotation",
      });
    }, [rotationJoystickData]);

    return <></>;
  };

  useEffect(() => {
    return () => {
      console.log("unmounting");
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
      if (revealEffectTimeoutRef.current) {
        clearTimeout(revealEffectTimeoutRef.current);
      }
      setIsDisplayUI(false);
      setSceneAnimationState("init");
    };
  }, []);

  useEffect(() => {
    console.log("modelLoadedState", modelLoadedState);
    console.log("coordReadyState", coordReadyState);
    if (!coordReadyState || !modelLoadedState) return;

    transitionTimeoutRef.current = setTimeout(() => {
      setSceneAnimationState("goDown");
    }, 1000);
    revealEffectTimeoutRef.current = setTimeout(() => {
      isDisplayEnteringMaskRef.current = false;
      isDisplayVenueNameRef.current = true;
      //TODO
      // if (gsplatMainRef.current) {
      //   gsplatMainRef.current.gsplat.enabled = true;
      //   createRadialScript();
      // }
      for (const [key, eachSplat] of Object.entries(gsplatAllRef.current)) {
        //console.log(key, value);
        eachSplat.gsplat.enabled = true;
        createRadialScript(mainObjectEntityRef.current, eachSplat);
      }
    }, 1000);
  }, [modelLoadedState, coordReadyState]);

  const FloorMeshContainer = () => {
    const baseUrl = getBaseUrl();
    const floorMeshPosition = mapSettingState.modelConfig.floorMeshPosition;
    const floorMeshUrl =
      baseUrl +
      mapSettingState.modelConfig!.folderPath +
      mapSettingState.modelConfig.floorMesh;
    return floorMeshUrl != "" ? (
      <FloorMeshComponent
        floorMeshUrl={floorMeshUrl}
        floorMeshPosition={[
          floorMeshPosition[0] / mapSettingState.modelConfig.scaleFactor,
          floorMeshPosition[1] / mapSettingState.modelConfig.scaleFactor,
          floorMeshPosition[2] / mapSettingState.modelConfig.scaleFactor,
        ]}
        floorMeshScale={[
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
        ]}
      />
    ) : (
      <></>
    );
  };

  const MainCamera = () => {
    const app = useApp();
    let _localProgress;
    let _localCameraMode;
    let isCameraModeUpdated;
    let nearestFixedCameraPosition;

    let _latestCameraPosition;
    let finalCameraLookingPosition;

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let orbitAnimationTime = 0;
    const orbitDuration = 5;

    let zoomInAvatarAnimationTime = 0;
    const zoomInAvatarDuration = 1;

    let goUpAnimationTime = 0;
    const goUpDuration = 3;

    let lostWallRaycastCount = 0;
    let isForceFirstPersonCamera = false;
    let previousWallBlockingCameraDistance = 0;

    const checkWallBlockingCameraDistance = (expectedCameraPosition) => {
      const rigidbodySystem = app.systems.rigidbody;
      if (!rigidbodySystem || !rigidbodySystem.dynamicsWorld) {
        return;
      }
      const currentPosition = mainObjectEntityRef.current.getPosition().clone();
      const from = new pc.Vec3(
        currentPosition.x,
        currentPosition.y,
        currentPosition.z,
      );
      const to = getNewFrontPosition(
        currentPosition,
        expectedCameraPosition,
        100,
      );
      const hit = rigidbodySystem.raycastFirst(from, to);
      if (hit && hit.entity.name.includes("obstacle")) {
        const distance = currentPosition.z - hit.point.z;
        return Math.abs(distance);
      } else {
        return null;
      }
    };

    const handleUpdate = useCallback((dt: number) => {
      if (cameraScriptRef.current == null) {
        return;
      }

      isCameraModeUpdated = _localCameraMode != latestCameraModeRef.current;
      _localCameraMode = latestCameraModeRef.current;

      if (sceneAnimationStateRef.current == "init") {
        _latestCameraPosition = topPositionRef.current;
        isDisplayEnteringMaskRef.current = true;
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          _latestCameraPosition,
        );
        setCameraPosition(topPositionRef.current);
        setCameraLookingPosition(defaultTargetRef.current);
        const cameraAngle = getYAngleDegree(
          mainObjectEntityRef.current.getPosition(),
          defaultTargetRef.current,
        );
        setCameraAngle(cameraAngle);
      } else if (sceneAnimationStateRef.current == "goDown") {
        if (goDownAnimationTime >= goDownDuration) {
          _latestCameraPosition = downPositionRef.current;
          cameraScriptRef.current.reset(
            mainObjectEntityRef.current.getPosition(),
            _latestCameraPosition,
          );
          setSceneAnimationState("orbit");
          return;
        }
        // if (goDownDuration - goDownAnimationTime < 1.5) {
        //   isDisplayEnteringMaskRef.current = false;
        // }
        goDownAnimationTime += dt;
        const t = Math.min(goDownAnimationTime / goDownDuration, 1);
        const newPos = new pc.Vec3().lerp(
          topPositionRef.current,
          downPositionRef.current,
          t,
        );
        _latestCameraPosition = newPos;
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          _latestCameraPosition,
        );
      } else if (sceneAnimationStateRef.current == "orbit") {
        if (orbitAnimationTime >= orbitDuration) {
          cameraScriptRef.current.reset(
            defaultTargetRef.current,
            mainObjectEntityRef.current.getPosition(),
          );
          setSceneAnimationState("free");
          isDisplayAvatarRef.current = false;
          setIsDisplayUI(true);
          for (const [key, eachSplat] of Object.entries(gsplatAllRef.current)) {
            eachSplat.removeComponent("script");
            eachSplat.addComponent("script");
            cleanup(app, eachSplat);
          }
          return;
        }
        if (orbitAnimationTime + 1.5 >= orbitDuration) {
          isDisplayVenueNameRef.current = false;
        }
        orbitAnimationTime += dt;
        const t = Math.min(orbitAnimationTime / orbitDuration, 1);
        const newCameraPosition = interpolateVector3(initCameraMovement, t);
        const offsetLocal = new pc.Vec3(
          -newCameraPosition[0],
          newCameraPosition[1],
          -newCameraPosition[2],
        );
        const offsetWorld = mainObjectEntityRef.current
          .getRotation()
          .transformVector(offsetLocal);
        const newPos = mainObjectEntityRef.current
          .getPosition()
          .clone()
          .add(offsetWorld);

        _latestCameraPosition = newPos;
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          _latestCameraPosition,
        );
      } else if (sceneAnimationStateRef.current == "free") {
        let expectedCamPosition =
          latestCameraModeRef.current == 0
            ? firstPersonCameraEntityRef.current.getPosition()
            : thirdPersonCameraEntityRef.current.getPosition();

        _latestCameraPosition = expectedCamPosition;

        let wallBlockingCameraDistance =
          checkWallBlockingCameraDistance(expectedCamPosition);
        if (
          wallBlockingCameraDistance != null &&
          wallBlockingCameraDistance < THIRD_PERSION_DISTANCE
        ) {
          isForceFirstPersonCamera = true;
          previousWallBlockingCameraDistance = wallBlockingCameraDistance;
        } else {
          if (isForceFirstPersonCamera) {
            lostWallRaycastCount += 1;
            wallBlockingCameraDistance = previousWallBlockingCameraDistance;
          }
          if (lostWallRaycastCount > 100) {
            lostWallRaycastCount = 0;
            isForceFirstPersonCamera = false;
          }
        }
        if (isForceFirstPersonCamera) {
          const adjustDistance =
            wallBlockingCameraDistance - 0.4 < 0
              ? 0
              : wallBlockingCameraDistance - 0.4;
          const adjustedCameraPosition = getNewFrontPosition(
            firstPersonCameraEntityRef.current.getPosition(),
            thirdPersonCameraEntityRef.current.getPosition(),
            adjustDistance,
          );
          _latestCameraPosition = adjustedCameraPosition;
        }

        //x
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          _latestCameraPosition,
        );

        isMovingRef.current = false;
        isRotatingRef.current = false;

        setCameraPosition(_latestCameraPosition);
        setCameraLookingPosition(mainObjectEntityRef.current.getPosition());
        const cameraAngle = getYAngleDegree(
          _latestCameraPosition,
          mainObjectEntityRef.current.getPosition(),
        );
        setCameraAngle(cameraAngle);
      } else if (sceneAnimationStateRef.current == "ending") {
        isDisplayAvatarRef.current = true;
        _latestCameraPosition = downPositionRef.current;
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          _latestCameraPosition,
        );

        if (goUpAnimationTime >= goUpDuration) {
          _latestCameraPosition = upPositionRef.current;
          cameraScriptRef.current.reset(
            mainObjectEntityRef.current.getPosition(),
            _latestCameraPosition,
          );
          return;
        }
        if (goUpAnimationTime > 0.5) {
          isDisplayLeavingMaskRef.current = true;
        }
        goUpAnimationTime += dt;
        const t = Math.min(goUpAnimationTime / goUpDuration, 1);
        const newPos = new pc.Vec3().lerp(
          downPositionRef.current,
          topPositionRef.current,
          t,
        );
        _latestCameraPosition = newPos;
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          _latestCameraPosition,
        );
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity name="MainCamera">
        <Camera fov={60} />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          enableFly={false}
        />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, -0.5]}></Entity>
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();
    const avatarEntityRef = useRef(null);
    const previousHit = useRef();

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let goUpAnimationTime = 0;
    const goUpDuration = 2;

    const eulerRef = useRef(new pc.Vec3(0, 180, 0));
    let _localResetPositionRotationEvent = 0;
    let _localResetOnlyRotationEvent = 0;
    let _localLeaveVenueEvent = 0;

    useEffect(() => {
      mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
    }, []);

    const adjustPositionWithRaycast = () => {
      const rigidbodySystem = app.systems.rigidbody;
      if (!rigidbodySystem || !rigidbodySystem.dynamicsWorld) {
        return;
      }
      if (isLevelChangingRef.current) {
        previousHit.current = null;
      }
      const currentPosition = mainObjectEntityRef.current.getPosition().clone();

      //Handle height
      const from = new pc.Vec3(
        currentPosition.x,
        currentPosition.y + 100,
        currentPosition.z,
      );
      const to = new pc.Vec3(
        currentPosition.x,
        currentPosition.y - 100,
        currentPosition.z,
      );
      const hit = rigidbodySystem.raycastFirst(from, to);
      if (hit && hit.entity.name.includes("ground")) {
        //console.log(hit.point);
        const verticalDistance = currentPosition.y - hit.point.y;
        if (verticalDistance < 20) {
          const adjustedPosition = new pc.Vec3(
            hit.point.x,
            hit.point.y + 1,
            hit.point.z,
          );
          mainObjectEntityRef.current.setPosition(adjustedPosition);
          previousHit.current = hit;
        }
        //const verticalDistance = camPos.y - hit.point.y;
        // use ref/state here, avoid console.log every frame
      } else if (previousHit.current) {
        const adjustedPosition = new pc.Vec3(
          currentPosition.x,
          previousHit.current.point.y + 1,
          currentPosition.z,
        );
        mainObjectEntityRef.current.setPosition(adjustedPosition);
      }
    };

    const handleUpdate = useCallback((dt: number) => {
      if (mainObjectEntityRef.current == null) {
        return;
      }
      let isResetPositionRotation =
        _localResetPositionRotationEvent !=
        latestResetPositionRotationEvent.current;
      _localResetPositionRotationEvent =
        latestResetPositionRotationEvent.current;
      let isResetOnlyRotation =
        _localResetOnlyRotationEvent != latestResetOnlyRotationEvent.current;
      _localResetOnlyRotationEvent = latestResetOnlyRotationEvent.current;

      let isLeaveVenue = _localLeaveVenueEvent != leaveVenueRef.current;
      _localLeaveVenueEvent = leaveVenueRef.current;

      if (sceneAnimationStateRef.current == "init") {
        isDisplayAvatarRef.current = true;
        mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
        mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
      } else if (sceneAnimationStateRef.current == "free") {
        if (latestPositionJoystickData.current.length != 2) {
          return;
        }

        if (isLevelChangingRef.current) {
          isMovingRef.current = true;
          const targetPosition = new pc.Vec3(
            mainObjectEntityRef.current.getPosition().x,
            targetAltitudeRef.current,
            mainObjectEntityRef.current.getPosition().z,
          );
          const distance = vec3Distance(
            mainObjectEntityRef.current.getPosition(),
            targetPosition,
          );
          const positionAlpha = Math.min(1, (3 * dt) / distance);
          mainObjectEntityRef.current.setPosition(targetPosition);
          isLevelChangingRef.current = false;
          triggerResetPositionRotationEvent();
        }

        if (
          latestPositionJoystickData.current[0] != 0 ||
          latestPositionJoystickData.current[1] != 0
        ) {
          isMovingRef.current = true;
          const worldMat = mainObjectEntityRef.current.getWorldTransform();
          const forward = new pc.Vec3(0, 0, -1);
          worldMat.transformVector(forward, forward);
          forward.y = 0;
          forward.normalize();
          const up = pc.Vec3.UP.clone();
          const right = new pc.Vec3();
          right.cross(up, forward).normalize();
          const forwardScale =
            latestPositionJoystickData.current[1] * moveSpeedRef.current * -dt;
          const rightScale =
            latestPositionJoystickData.current[0] * moveSpeedRef.current * -dt;
          const forwardMove = forward.clone().mulScalar(forwardScale);
          const rightMove = right.clone().mulScalar(rightScale);
          const move = new pc.Vec3();
          move.add(forwardMove).add(rightMove);
          mainObjectEntityRef.current.translate(move);
          adjustPositionWithRaycast();
        }

        if (
          latestRotationJoystickData.current[0] != 0 ||
          latestRotationJoystickData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationJoystickData.current[0] *
            rotateSpeedRef.current *
            dt; // Yaw
          eulerRef.current.x +=
            -latestRotationJoystickData.current[1] *
            rotateSpeedRef.current *
            dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        if (
          latestRotationScreenData.current[0] != 0 ||
          latestRotationScreenData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationScreenData.current[0] * rotateSpeedRef.current * dt; // Yaw
          eulerRef.current.x +=
            -latestRotationScreenData.current[1] * rotateSpeedRef.current * dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        // handle reset
        if (isResetPositionRotation) {
          isMovingRef.current = true;
          isRotatingRef.current = true;

          const floorData = getModelConfigMapByLcMapId(
            mapSettingState.modelConfig,
            currentLcMapIdRef.current,
          );
          if (
            floorData != null &&
            floorData.defaultPosition != null &&
            floorData.defaultTarget != null
          ) {
            const resetPosition = new pc.Vec3(
              floorData.defaultPosition[0] / modelScaleFactorRef.current,
              floorData.defaultPosition[1] / modelScaleFactorRef.current,
              floorData.defaultPosition[2] / modelScaleFactorRef.current,
            );
            const resetTarget = new pc.Vec3(
              floorData.defaultTarget[0] / modelScaleFactorRef.current,
              floorData.defaultTarget[1] / modelScaleFactorRef.current,
              floorData.defaultTarget[2] / modelScaleFactorRef.current,
            );
            mainObjectEntityRef.current.setPosition(resetPosition);
            const targetAngle = getYAngleDegree(resetPosition, resetTarget);
            eulerRef.current.x = 0;
            eulerRef.current.y = -targetAngle + 180;
            eulerRef.current.z = 0;
            mainObjectEntityRef.current.setLocalEulerAngles(
              eulerRef.current.x,
              eulerRef.current.y,
              eulerRef.current.z,
            );
          } else {
            mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
            mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
          }
          adjustPositionWithRaycast();
        }
        if (isResetOnlyRotation) {
          isRotatingRef.current = true;
          eulerRef.current.x = 0;
          mainObjectEntityRef.current.setLocalEulerAngles(
            eulerRef.current.x,
            eulerRef.current.y,
            eulerRef.current.z,
          );
        }
        if (isLeaveVenue) {
          mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
          adjustPositionWithRaycast();
          setSceneAnimationState("ending");
          //setIsDisplayUI(false);
          setIsDisplayTopViewScene(false);
          setTimeout(() => {
            setIsDisplayUI(false);
          }, 100);
        }
      }

      if (avatarEntityRef.current) {
        avatarEntityRef.current.enabled =
          latestCameraModeRef.current == 1 || isDisplayAvatarRef.current;
      }
    }, []);
    useAppEvent("update", handleUpdate);
    return (
      <Entity ref={mainObjectEntityRef}>
        <Entity ref={avatarEntityRef}>
          <RobotAvatar
            avatarUrl={mapSettingState.avatar}
            isFloating={mapSettingState.avatarIsFloating}
          />
        </Entity>
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.5]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.5, THIRD_PERSION_DISTANCE]}
        ></Entity>
      </Entity>
    );
  };

  const cleanup = (app, gsplatEntity) => {
    const cleanup = installCameraNearFar(
      app,
      gsplatEntity,
      hiddenNearRef.current,
      hiddenFarRef.current,
    );
    return cleanup;
  };

  // const TempPoi = ({ imageUrl, position, rotation }) => {
  //   const app = useApp();
  //   const frontRef = useRef(null);
  //   const backRef = useRef(null);
  //   const floatingEntityRef = useRef(null);

  //   const whiteMaterial = useMaterial({
  //     emissive: [1, 1, 1],
  //     emissiveIntensity: 2,
  //   });

  //   useEffect(() => {
  //     if (!app) return;
  //     const textureAsset = new pc.Asset("myTexture", "texture", {
  //       url: imageUrl,
  //     });
  //     app.assets.add(textureAsset);
  //     app.assets.load(textureAsset);
  //     textureAsset.on("load", () => {
  //       [frontRef.current, backRef.current].forEach((entity, i) => {
  //         if (entity?.render?.material) {
  //           entity.render.material.emissiveMap = textureAsset.resource; // Self-lit texture
  //           entity.render.material.emissiveIntensity = 1.2;
  //           entity.render.material.emissiveTint = [1, 1, 1, 1];
  //           entity.render.material.update();
  //         }
  //       });
  //     });
  //     let time = 0;
  //     const originalY = 1;
  //     function updateFloating(dt) {
  //       time += dt;
  //       if (floatingEntityRef.current) {
  //         const floatOffset = Math.sin(time * 2) * 0.3; // Up/down only
  //         floatingEntityRef.current.setLocalPosition(
  //           0,
  //           originalY + floatOffset,
  //           0,
  //         );
  //       }
  //     }
  //     app.on("update", updateFloating);
  //     return () => {
  //       app.off("update", updateFloating);
  //     };
  //   }, [app]);

  //   return (
  //     <Entity position={position} scale={[0.8, 0.8, 0.8]} rotation={rotation}>
  //       <Entity ref={floatingEntityRef}>
  //         <Entity rotation={[90, 0, 0]} ref={frontRef}>
  //           <Render type="plane" material={whiteMaterial} />
  //         </Entity>
  //         <Entity rotation={[90, 180, 0]} ref={backRef}>
  //           <Render type="plane" material={whiteMaterial} />
  //         </Entity>
  //       </Entity>
  //     </Entity>
  //   );
  // };

  const CirclePoi = ({ colorHex, textureUrl, position, rotation }) => {
    const app = useApp();
    const entityRef = useRef();
    const floatingEntityRef = useRef(null);

    let floatTime = 0;
    const _avatarPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const { asset: model } = useModel(
      "https://assets.deepworldmodel.ai/poi_model/circle_poi.glb",
    );
    console.log("load texture url " + textureUrl);
    const { asset: newTextureAsset } = useTexture(textureUrl);

    useEffect(() => {
      if (!app) return;
      let time = 0;
      const originalY = 1;
      function updateFloating(dt) {
        time += dt;
        if (floatingEntityRef.current) {
          const floatOffset = Math.sin(time * 2) * 0.2; // Up/down only
          floatingEntityRef.current.setLocalPosition(
            0,
            originalY + floatOffset,
            0,
          );
        }
      }
      app.on("update", updateFloating);
      return () => {
        app.off("update", updateFloating);
      };
    }, [app]);

    const changeMaterial = (entity) => {
      console.log("change material");
      console.log(newTextureAsset);
      if (entity == null || newTextureAsset == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material.clone();
            if (material) {
              if (material.name === "color") {
                // For "color" material: pure emissive tint (no texture needed)
                material.emissiveMap = null;
                material.emissiveIntensity = 1.0;
                const newColor = hexToRgbArray(colorHex);
                material.emissive = new pc.Color(
                  newColor[0],
                  newColor[1],
                  newColor[2],
                ); // Custom pinkish tint - adjust RGB as needed
                material.diffuse = new pc.Color(
                  newColor[0],
                  newColor[1],
                  newColor[2],
                ); // Fallback tint
                material.useLighting = false;
              } else if (material.name === "texture") {
                // Load new texture if available, otherwise keep existing
                if (newTextureAsset?.resource) {
                  material.diffuseMap = newTextureAsset.resource;
                  material.emissiveMap = newTextureAsset.resource; // Also use as emissive
                }
                material.emissiveIntensity = 1.2;
                material.emissive = new pc.Color(1, 1, 1);
                material.useLighting = false;
              }
              material.update();
              meshInstance.material = material;
            }
          });
        }
      });
    };

    useEffect(() => {
      if (model && entityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(entityRef.current);
        });
      }
    }, [model, newTextureAsset]);

    return model ? (
      <Entity position={position} rotation={rotation}>
        <Entity ref={floatingEntityRef}>
          <Entity ref={entityRef} scale={[0.4, 0.4, 0.4]}>
            <Render type="asset" asset={model} />
          </Entity>
        </Entity>
      </Entity>
    ) : (
      <></>
    );
  };

  const TestingPois = () => {
    return (
      <>
        {mapSettingState.modelConfig!.testingPois.map((item, index) => (
          <CirclePoi
            key={item.key}
            colorHex={item.colorHex}
            textureUrl={item.textureUrl}
            position={item.position}
            rotation={item.rotation}
          />
        ))}
      </>
    );
  };

  const MeshModels = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    return (
      <>
        {mapSettingState.modelConfig!.mesh.meshModels.map((item, index) => (
          <Fragment key={item.index}>
            <MeshModelComponent
              app={app}
              cameraName={"MainCamera"}
              meshUrl={
                baseUrl + mapSettingState.modelConfig!.folderPath + item.url
              }
              meshPosition={[
                item.position[0] / mapSettingState.modelConfig.scaleFactor,
                item.position[1] / mapSettingState.modelConfig.scaleFactor,
                item.position[2] / mapSettingState.modelConfig.scaleFactor,
              ]}
              meshRotationAngle={item.rotationAngle}
              meshScale={[
                item.scale[0] / mapSettingState.modelConfig.scaleFactor,
                item.scale[1] / mapSettingState.modelConfig.scaleFactor,
                item.scale[2] / mapSettingState.modelConfig.scaleFactor,
              ]}
              meshColor={item.color ?? "#FFFFFF"}
              meshOpacity={item.opacity ?? 1}
              rotateObjects={item.rotateObjects ?? []}
            />
          </Fragment>
        ))}
      </>
    );
  };

  const SingleLod = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const isSplatReadyRef = useRef(false);
    const worstLevelRef = useRef(2);
    const lodLink =
      baseUrl +
      mapSettingState.modelConfig!.folderPath +
      mapSettingState.modelConfig!.splat?.singleLod;

    const splatFirstFrameHandler = (camera, layer, ready, loadingCount) => {
      if (ready && loadingCount == 0) {
        app.systems.gsplat.off("frame:ready", splatFirstFrameHandler);
        afterFirstFrameReady();
      }
    };
    const callbackAssetReadyFunction = (splat, asset) => {
      gsplatAllRef.current["single"] = splat;
      console.log("single lod assets ready !!!!!!!!!");
      splat.gsplat.enabled = true;
      const worstLevel =
        splat.gsplat.resource?.octree?.lodLevels != null
          ? splat.gsplat.resource?.octree?.lodLevels - 1
          : 0;
      worstLevelRef.current = worstLevel;
      splat.gsplat.lodRangeMin = worstLevel;
      splat.gsplat.lodRangeMax = worstLevel;
      app.systems.gsplat.on("frame:ready", splatFirstFrameHandler);
      return () =>
        app.systems.gsplat.off("frame:ready", splatFirstFrameHandler);
    };
    const afterFirstFrameReady = () => {
      console.log("after single lod first frame ready");
      gsplatAllRef.current["single"].gsplat.lodRangeMin = 0;
      gsplatAllRef.current["single"].gsplat.lodRangeMax = worstLevelRef.current;
      isSplatReadyRef.current = true;
      setModelLoadedState(true);
      enableXRayMode();
    };

    return (
      <SplatLodComponent
        app={app}
        url={lodLink}
        position={[0, 0, 0]}
        rotation={[180, 0, 0]}
        scale={[
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
        ]}
        lodDistances={mapSettingState.modelConfig.scaleFactor}
        callbackReady={callbackAssetReadyFunction}
      />
    );
  };

  const FloorLod = () => {
    {
      return (
        <>
          {mapSettingState.modelConfig!.floor.map((item, index) =>
            item.lod ? (
              <Fragment key={index}>
                <EachFloorLod floorSetting={item} />
              </Fragment>
            ) : (
              <Fragment key={index}></Fragment>
            ),
          )}
        </>
      );
    }
  };

  const EachFloorLod = ({ floorSetting }) => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const assetModel = useRef();
    const isSplatReadyRef = useRef(false);
    const targetLodRangeMinRef = useRef(2);
    const worstLevelRef = useRef(2);
    const lodLink =
      baseUrl + mapSettingState.modelConfig!.folderPath + floorSetting.lod;
    const mapAlign = findMapAlignWithLcMapId(
      mapSettingState.floorAlignment,
      floorSetting.lcMapId,
    );
    const scaleFactor = SCALE_BASE / mapAlign.scale;

    const currentLcMapId = useExplorationStore((state) => state.currentLcMapId);

    const handleUpdate = useCallback((dt: number) => {
      if (!isSplatReadyRef.current) {
        return;
      }
      if (
        !gsplatAllRef.current[floorSetting.lcMapId] ||
        !gsplatAllRef.current[floorSetting.lcMapId].gsplat
      ) {
        return;
      }
      if (floorSetting.lcMapId == currentLcMapIdRef.current) {
        splatDisplayLcMapIdRef.current = floorSetting.displayLod;
      }
      if (
        gsplatAllRef.current[floorSetting.lcMapId] == null ||
        splatDisplayLcMapIdRef.current == null
      ) {
        return;
      }
      if (splatDisplayLcMapIdRef.current.includes(floorSetting.lcMapId)) {
        if (!gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled) {
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled = true;
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.asset =
            assetModel.current;
        } else {
          if (
            gsplatAllRef.current[floorSetting.lcMapId].gsplat.lodRangeMin >
            targetLodRangeMinRef.current
          ) {
            //When current LOD is above 0 , wait for the current LOD display (e.g. LOD 2) and set the to higher quality LOD
            if (
              !isSplatLoadingRef.current &&
              splatLoadingCountRef.current == 0
            ) {
              gsplatAllRef.current[floorSetting.lcMapId].gsplat.lodRangeMin =
                targetLodRangeMinRef.current;
              if (targetLodRangeMinRef.current > 0) {
                setTimeout(() => {
                  targetLodRangeMinRef.current -= 1;
                }, 500);
              }
            }
          }
        }
      } else {
        if (gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled) {
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled = false;
          //gsplatAllRef.current[floorSetting.lcMapId].gsplat.asset = null;
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);

    const splatFirstFrameHandler = (camera, layer, ready, loadingCount) => {
      if (ready && loadingCount == 0) {
        app.systems.gsplat.off("frame:ready", splatFirstFrameHandler);
        afterFirstFrameReady();
      }
    };

    const callbackAssetReadyFunction = (splat, asset) => {
      gsplatAllRef.current[floorSetting.lcMapId] = splat;
      assetModel.current = asset;
      splat.gsplat.enabled = true;
      const worstLevel =
        splat.gsplat.resource?.octree?.lodLevels != null
          ? splat.gsplat.resource?.octree?.lodLevels - 1
          : 0;
      worstLevelRef.current = worstLevel;
      splat.gsplat.lodRangeMin = worstLevel;
      splat.gsplat.lodRangeMax = worstLevel;
      targetLodRangeMinRef.current =
        worstLevel > 0 ? worstLevel - 1 : worstLevel;
      app.systems.gsplat.on("frame:ready", splatFirstFrameHandler);
      return () =>
        app.systems.gsplat.off("frame:ready", splatFirstFrameHandler);
    };

    const afterFirstFrameReady = () => {
      console.log("after first frame ready " + floorSetting.lcMapId);
      isSplatReadyRef.current = true;
      setModelLoadedState(true);
      enableXRayMode();
    };

    return (
      <>
        {currentLcMapId == floorSetting.lcMapId ? (
          <SplatLodComponent
            app={app}
            url={lodLink}
            position={[0, floorSetting.yAxis / scaleFactor, 0]}
            rotation={[180, 0, 0]}
            scale={[1 / scaleFactor, 1 / scaleFactor, 1 / scaleFactor]}
            lodDistances={scaleFactor}
            callbackReady={callbackAssetReadyFunction}
          />
        ) : (
          <></>
        )}
      </>
    );
  };

  const Splat = () => {
    return (
      <>
        {mapSettingState.modelConfig!.splat?.mode == "singleLod" ? (
          <SingleLod />
        ) : mapSettingState.modelConfig!.splat?.mode == "floorLod" ? (
          <FloorLod />
        ) : (
          <></>
        )}
      </>
    );
  };

  const AllFloorMeshGround = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();

    return (
      <>
        {mapSettingState.modelConfig!.floor.map((item, index) => {
          if (!item.meshGround) {
            return null;
          }
          const mapAlign = findMapAlignWithLcMapId(
            mapSettingState.floorAlignment,
            item.lcMapId,
          );
          const scaleFactor = SCALE_BASE / mapAlign.scale;
          const meshY = item.yAxis / scaleFactor;
          const meshGroundUrl =
            baseUrl +
            mapSettingState.modelConfig!.folderPath +
            (item.meshGround ?? "");
          const meshObstacleUrl =
            baseUrl +
            mapSettingState.modelConfig!.folderPath +
            (item.meshObstacle ?? "");

          return (
            <Fragment key={item.lcMapId}>
              {item.meshGround ? (
                <>
                  <EachFloorMesh
                    app={app}
                    type={"ground"}
                    lcMapId={item.lcMapId}
                    meshUrl={meshGroundUrl}
                    meshPosition={[0, meshY, 0]}
                    meshRotation={[0, 180, 0]}
                    meshScale={[
                      1 / scaleFactor,
                      1 / scaleFactor,
                      1 / scaleFactor,
                    ]}
                  />
                </>
              ) : (
                <></>
              )}
              {item.meshObstacle ? (
                <>
                  <EachFloorMesh
                    app={app}
                    type={"obstacle"}
                    lcMapId={item.lcMapId}
                    meshUrl={meshObstacleUrl}
                    meshPosition={[0, meshY, 0]}
                    meshRotation={[0, 180, 0]}
                    meshScale={[
                      1 / scaleFactor,
                      1 / scaleFactor,
                      1 / scaleFactor,
                    ]}
                  />
                </>
              ) : (
                <></>
              )}
            </Fragment>
          );
        })}
      </>
    );
  };

  const EachFloorMesh = ({
    app,
    type,
    lcMapId,
    meshUrl,
    meshPosition,
    meshRotation,
    meshScale,
  }: {
    app: any;
    type: string;
    lcMapId: string;
    meshUrl: string;
    meshPosition: number[];
    meshRotation: number[];
    meshScale: number[];
  }) => {
    const [isFirstDisplayedState, setIsFirstDisplayedState] =
      useState<boolean>(false);
    const isFirstDisplayedRef = useRef<boolean>(false);
    const meshOpacity = 1;
    const meshEntityRef = useRef();
    const meshInnerEntityRef = useRef();
    const isCollisionSetRef = useRef();
    const { asset: meshAsset } = useModel(meshUrl);
    const enableCollision = () => {
      if (
        isFirstDisplayedRef.current &&
        meshInnerEntityRef.current?.collision != null &&
        meshAsset != null
      ) {
        meshInnerEntityRef.current.collision.type = "mesh";
        meshInnerEntityRef.current.collision.renderAsset =
          meshAsset.resource.renders[0];
        isCollisionSetRef.current = true;
      } else {
        requestAnimationFrame(() => {
          enableCollision();
        });
      }
    };
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        meshEntityRef.current.enabled = false;
        requestAnimationFrame(() => {
          enableCollision();
        });
      }
    }, [meshAsset]);

    const handleUpdate = useCallback((dt: number) => {
      meshEntityRef.current.enabled = currentLcMapIdRef.current == lcMapId;
      if (
        currentLcMapIdRef.current == lcMapId &&
        !isFirstDisplayedRef.current
      ) {
        setIsFirstDisplayedState(true);
        isFirstDisplayedRef.current = true;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity
        ref={meshEntityRef}
        name={"FloorMesh_" + lcMapId}
        position={meshPosition}
        rotation={meshRotation}
        scale={meshScale}
        enabled={false}
      >
        {isFirstDisplayedState ? (
          <Entity ref={meshInnerEntityRef} name={type + "_" + lcMapId}>
            <RigidBody type="static" />
            <Collision type="box" convexHull={false} />
            {/*
              <Render type="asset" asset={meshAsset} />
            */}
          </Entity>
        ) : (
          <></>
        )}
      </Entity>
    );
  };

  const ClockModel = ({ url }) => {
    const entityRef = useRef();
    const { asset: model } = useModel(url);

    const changeMaterial = (entity) => {
      if (entity == null) return;
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material.clone();
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = false;
              material.update();
            }
            meshInstance.material = material;
          });
        }
      });
    };

    const setDigitValue = (digitEntity, digitValue) => {
      if (!digitEntity) return;
      const render = digitEntity.findComponent("render");
      if (render && render.meshInstances && render.meshInstances[0]) {
        const material = render.meshInstances[0].material;
        if (material) {
          const uOffset = digitValue * 0.1;
          material.diffuseMapOffset.set(uOffset, 0);
          material.emissiveMapOffset.set(uOffset, 0);
          material.update();
        }
      }
    };

    useEffect(() => {
      if (model && entityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(entityRef.current);
        });
        const timer = setInterval(() => {
          const root = entityRef.current;
          if (!root) return;
          const now = new Date();
          const hours = String(now.getHours()).padStart(2, "0");
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const seconds = String(now.getSeconds()).padStart(2, "0");
          const timeStr = hours + minutes + seconds;
          const digit0 = root.findByName("H");
          const digit1 = root.findByName("h");
          const digit2 = root.findByName("M");
          const digit3 = root.findByName("m");
          const digit4 = root.findByName("S");
          const digit5 = root.findByName("s");
          setDigitValue(digit0, parseInt(timeStr[0], 10));
          setDigitValue(digit1, parseInt(timeStr[1], 10));
          setDigitValue(digit2, parseInt(timeStr[2], 10));
          setDigitValue(digit3, parseInt(timeStr[3], 10));
          setDigitValue(digit4, parseInt(timeStr[4], 10));
          setDigitValue(digit5, parseInt(timeStr[5], 10));
        }, 1000);
        return () => clearInterval(timer);
      }
    }, [model]);
    return model ? (
      <Entity>
        <Entity ref={entityRef}>
          <Render type="asset" asset={model} />
        </Entity>
      </Entity>
    ) : (
      <></>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();

    useEffect(() => {
      const splatLoadingUpdate = (camera, layer, ready, loadingCount) => {
        isSplatLoadingRef.current = !ready;
        splatLoadingCountRef.current = loadingCount;
      };
      if (app && app?.systems?.gsplat != null) {
        app.systems.gsplat.on("frame:ready", splatLoadingUpdate);
      }
      return () => {
        if (app && app?.systems?.gsplat != null) {
          app.systems.gsplat.off("frame:ready", splatLoadingUpdate);
        }
      };
    }, [app]);

    useEffect(() => {
      return () => {};
    }, []);

    return (
      <>
        {/*        <Entity
          position={[12.5188, 1, 35.3602]}
          rotation={[0, 180, 0]}
          scale={[1, 1, 1]}
        >
          <ClockModel
            url={"https://assets.deepworldmodel.ai/model/clock_v2.glb"}
          />
        </Entity>*/}

        {mapSettingState.modelConfig!.splat ? <Splat /> : <></>}
        {mapSettingState.modelConfig!.testingPois ? <TestingPois /> : <></>}
        {mapSettingState.modelConfig!.mesh ? <MeshModels /> : <></>}
        {mapSettingState.modelConfig!.floorMesh ? (
          <FloorMeshContainer />
        ) : (
          <></>
        )}
        {mapSettingState.modelConfig!.floor ? <AllFloorMeshGround /> : <></>}

        {/*<Annotation />*/}
        {mapSettingState.modelConfig ? (
          <>
            <MainObject />
            <MainCamera />
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const Scene = () => {
    return (
      <Application
        usePhysics={true}
        maxDeltaTime={0.033}
        timeScale={1.0}
        graphicsDeviceOptions={{
          powerPreference: "default",
          alpha: false,
          antialias: false,
          preferWebGl2: true,
          stencil: false,
        }}
      >
        {mapSettingState != null && mapSettingState.modelConfig != null ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  const DragController = () => {
    const currentVenue = useExplorationStore((state) => state.currentVenue);
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      trackGAEvent(EVENT.EXPLORE_INTERACTION, {
        mode: "exploration",
        currentVenue,
      });
      trackEvent(AMPLITUDE_EVENT.EXPLORE_INTERACTION, {
        mode: "exploration",
        currentVenue,
      });
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      latestRotationScreenData.current[0] = xChange * 0.5;
      latestRotationScreenData.current[1] = yChange * 0.5;
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
      latestRotationScreenData.current[0] = 0;
      latestRotationScreenData.current[1] = 0;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  const EnterLoading = () => {
    const [isDisplayMask, setIsDisplayMask] = useState<boolean>(true);
    const opacityRef = useRef<number>(1);
    const divRef = useRef<HTMLDivElement>(null);
    const EACH_OPACITY = 0.02;
    const animationRef = useRef<number>(0);
    const keepCheckLoading = () => {
      if (!isDisplayEnteringMaskRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      setIsDisplayMask(opacityRef.current > 0);

      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return isDisplayMask ? (
      <div
        ref={divRef}
        className={`fullscreen_div flex items-center justify-center z-[60]`}
      >
        <div className="fullscreen_div bg-[#FFFFFF99] backdrop-blur-md"></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const LeaveLoading = () => {
    const [isDisplayMask, setIsDisplayMask] = useState<boolean>(false);
    const opacityRef = useRef<number>(0);
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const EACH_OPACITY = 0.02;
    const keepCheckLoading = () => {
      if (!isDisplayLeavingMaskRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      setIsDisplayMask(opacityRef.current > 0);

      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return isDisplayMask ? (
      <div
        ref={divRef}
        className={`fullscreen_div flex items-center justify-center z-[60]`}
      >
        <div className="fullscreen_div bg-[#FFFFFF99] backdrop-blur-md"></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const VenueName = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const opacityRef = useRef<number>(0);
    const EACH_OPACITY = 0.02;
    const keepCheckLoading = () => {
      if (!isDisplayVenueNameRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    const venueName = useExplorationStore((state) => state.currentVenueName);
    return (
      <div
        ref={divRef}
        className={`fullscreen_div flex flex-col items-center justify-center pointer-events-none`}
      >
        <div>
          <Image src="/assets/icon_map_pin.png" height={60} width={60} />
        </div>
        <div
          className={`text-[#E5E9EDE5] font-extrabold text-[46px] text-center`}
        >
          {venueName.toUpperCase()}
        </div>
      </div>
    );
  };

  console.log(
    "ExplorationPage component rendered , if this keep showing, something wrong",
  );

  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: "black" }}
    >
      <DataController />
      <Scene />
      <DragController />
      <EnterLoading />
      <LeaveLoading />
      <VenueName />
      <WatermarkScreen />
    </div>
  );
}
